import { gql } from '@apollo/client';

/**
 * 查询导出进度
 */
export const GET_EXPORT_PROGRESS = gql`
  query GetExportProgress($taskId: ID!) {
    getExportProgress(taskId: $taskId) {
      taskId
      status
      progress
      currentStep
      errorMessage
      fileName
      fileSize
      fileType
      createdAt
      startedAt
      completedAt
    }
  }
`;

/**
 * 查询导出历史
 */
export const GET_EXPORT_FILE_DOWNLOAD_URL = gql`
  query GetExportFileDownloadUrl($taskId: ID!) {
    getExportFileDownloadUrl(taskId: $taskId)
  }
`;

export const GET_EXPORT_HISTORY = gql`
  query GetExportHistory(
    $billId: ID
    $clientId: ID
    $pageRequest: PageRequestInput
  ) {
    getExportHistory(
      billId: $billId
      clientId: $clientId
      pageRequest: $pageRequest
    ) {
      content {
        taskId
        billId
        clientId
        clientName
        templateType
        fileType
        exportFormat
        status
        progress
        currentStep
        fileName
        fileSize
        operatorId
        operatorName
        createdAt
        completedAt
        errorMessage
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

/**
 * 获取最新导出文件
 */
export const GET_LATEST_EXPORT_FILE = gql`
  query GetLatestExportFile($billId: ID!) {
    getLatestExportFile(billId: $billId) {
      taskId
      fileName
      fileSize
      createdAt
    }
  }
`;

